import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconClock9OClock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconClock9OClock"><Path d="M12 6.75V12H7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
});

export default IconClock9OClock;
